import { doSetConfig } from "../actions/config";
import url from "../api";
import { CONFIG_FETCH } from "../constants/actionTypes";
import { call, select } from "typed-redux-saga";
import { put, takeLatest } from "redux-saga/effects";
import { makeApiCall } from "./general";
import { getFilters } from "../selectors/config";
import { isUserAuthenticated } from "../selectors/user";
import type { Config } from "../types/config";

export default function* configSaga(): Generator {
  yield takeLatest(CONFIG_FETCH, handleFetchConfig);
}

export function* handleFetchConfig(): Generator {
  const filters = yield* select(getFilters);
  const token = yield* select(isUserAuthenticated);

  if (!filters || filters.length === 0) {
    const { config, featureFlags } = url;
    const data: Config = yield* call(makeApiCall, config, null, {
      headers: {
        "ALBAIK-Auth-Token": token,
      },
    });

    yield put(doSetConfig(data));

    const featureFlagsData = yield* call(makeApiCall, featureFlags, null, {
      headers: {
        "ALBAIK-Auth-Token": token,
      },
    });

    yield put(
      doSetConfig({
        ...data,
        featureFlags: {
          ...data.featureFlags,
          enableAsyncFlowForTpos: Boolean(
            featureFlagsData?.enableAsyncFlowForTpos,
          ),
          enableCombosForTpos: Boolean(featureFlagsData?.enableCombosForTpos),
        },
      }),
    );
  }
}
